import React from "react";
import { ComponentRenderer } from "../components/ComponentRenderer";
import { screen_100_home } from "../config/100_home";

export const Components: React.FC = () => {
  const handleFormDataChange = (name: string, value: any) => {
    console.log("Form data changed:", { name, value });
  };

  const handleActionTrigger = (actionId: string, data?: any) => {
    console.log("Action triggered:", { actionId, data });

    // Handle specific actions
    switch (actionId) {
      case "save_action":
        console.log("Save action performed");
        // Add your save logic here
        break;
      case "cancel_action":
        console.log("Cancel action performed");
        // Add your cancel logic here
        break;
      default:
        console.log("Unknown action:", actionId);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-200">
      <ComponentRenderer
        config={screen_100_home}
        onFormDataChange={handleFormDataChange}
        onActionTrigger={handleActionTrigger}
      />
    </div>
  );
};
